export default __webpack_public_path__ + "static/media/plus.47c32f4f.svg";